import React, {Component} from "react"
import {Link} from "react-router"
import {injectIntl} from "react-intl"
import {connect} from "react-redux"
import default_user_img from './img/default_user.png'
import ImageUploadModal from "../../components/ImageUploadModal"
import {queryUserInfo, queryUserInfoById} from '../../dispatch'
import {PATH_USER_IMAGE_UPLOAD} from 'constants'
import {PATH_USER_IMAGE_UPLOAD_BY_ID} from "../../constants"
import UserFormModal from "../../routes/enterprise/components/UserFormModal"
import {predicateFunctions} from "../../routes/AuthWrappers"

const mapDispatchToProps = {
  queryUserInfo, queryUserInfoById
}


const mapStateToProps = (state) => ({
  user: state.user
})

class UserInfo extends Component {

  constructor() {
    super()
    this.state = {
      userModalOpen: false,
      uploadImageModalOpen: false
    }
  }

  openImageModal = () => {
    this.setState({uploadImageModalOpen: true})
  }
  closeImageModal = () => {
    this.setState({uploadImageModalOpen: false})
  }

  render() {

    const format = this.props.intl.formatMessage
    const user = this.props.user
    const t = new Date().getTime()
    const userImage = user.profileImagePath ? user.profileImagePath + '?t=' + t : default_user_img

    const isAdmin = predicateFunctions['UserIsAdminOrOps'](user)
    const adminLink = isAdmin ?
      <Link className="m-l-md" aria-expanded="false" role="button" to="/admin">
        <i className="fa fa-university"></i>
        {format({id: 'nav.admin'})}
      </Link> : ``

    return (
      <div className="dropdown profile-element">

        <span className="clear">
          <span className="block m-t-xs">
            <strong className="font-bold" style={{color:"#dfe4ed"}}>
              {format({id: 'nav.cogoland.enterprise.portal'})}
            </strong>
          </span>
          <span className="block m-t-lg">
            <strong className="font-bold" style={{color:"#dfe4ed"}}>{user.name}</strong>
          </span>
          <span className="text-muted text-xs block">
            {user.username}
          </span>
        </span>
      </div>
    )
  }

}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UserInfo))



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/UserInfo.js